import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { SiteLayout } from "@/types";
import { fetchSelectedLayout } from "./thunk";

export interface LayoutState {
  layout: Partial<SiteLayout>;
  status: "idle" | "fetching";
  error: string | null;
}

const initialState: LayoutState = {
  layout: {},
  status: "idle",
  error: null
};

export const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[layoutSlice.name]
        };
      })
      .addCase(fetchSelectedLayout.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchSelectedLayout.fulfilled, (state, action) => {
        state.status = "idle";
        state.layout = action.payload;
        state.error = null;
      })
      .addCase(fetchSelectedLayout.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message || null;
      });
  }
});
